// hooks/useSpecialistQualifications.ts
import { useQuery } from '@tanstack/react-query';
import {
  getAdditionalQualificationData,
  getServiceQualifications,
  getSpecialisationData,
  getTreatmentServices
} from '../../services';

export const useSpecialistQualifications = () => {
  const specialisationsQuery = useQuery({
    queryKey: ['specialisations'],
    queryFn: getSpecialisationData
  });

  const additionalQualificationsQuery = useQuery({
    queryKey: ['additionalQualifications'],
    queryFn: getAdditionalQualificationData
  });

  const treatmentsQuery = useQuery({
    queryKey: ['treatments'],
    queryFn: getTreatmentServices
  });

  const serviceQualificationsQuery = useQuery({
    queryKey: ['serviceQualifications'],
    queryFn: getServiceQualifications
  });

  // Aggregate loading state
  const isLoading =
    specialisationsQuery.isLoading ||
    additionalQualificationsQuery.isLoading ||
    treatmentsQuery.isLoading ||
    serviceQualificationsQuery.isLoading;

  // Aggregate error state
  const isError =
    specialisationsQuery.isError ||
    additionalQualificationsQuery.isError ||
    treatmentsQuery.isError ||
    serviceQualificationsQuery.isError;

  return {
    specialisationsQuery,
    additionalQualificationsQuery,
    treatmentsQuery,
    serviceQualificationsQuery,
    isLoading,
    isError
  };
};
